export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '课程名称',
    field: 'name',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '课程编号',
    field: 'code'
  },
  {
    headerName: '课程分类',
    field: 'programCategoryName'
  },
  {
    headerName: '组织名称',
    field: 'orgName'
  },
  {
    headerName: '组织编码',
    field: 'orgCode'
  },
  {
    headerName: '组织类型',
    field: 'nodeCategoryName'
  },
  {
    headerName: '培训人数',
    field: 'factCount'
  },
  {
    headerName: '培训人次',
    field: 'times'
  },
  {
    headerName: '通过人数',
    field: 'passCount'
  },
  {
    headerName: '通过率',
    field: 'passRate'
  }
]
